import React from 'react';
import Editor from '@/components/atom/Editor';
import SectionLabel from '@/components/molecule/SectionLabel';
import Label from '@/components/atom/Label';
import FormItem from '@/components/molecule/FormItem';
import { useForm } from 'react-hook-form';

function CkEditorTestPage() {
  const { control } = useForm({
    mode: 'onBlur',
  });
  return (
    <>
      <h1 className="mb-[20px] mt-[20px] text-2xl">CK 에디터</h1>
      <div className="col-span-1 flex flex-col gap-y-4">
        <FormItem
          control={control}
          label="제목"
          labelSize="M"
          size="M"
          name="questionKr"
          type="text"
          direction="horizontal"
          inputProps={{
            placeholder: '제목을 입력해주세요',
          }}
          rules={{ required: true }}
        />
        <SectionLabel
          label={<Label required>컨텐츠</Label>}
          value={
            <div className="flex-1">
              <Editor
                height={500}
                value=""
                placeholder="내용을 입력해주세요."
              />
              ;
            </div>
          }
        />
      </div>
    </>
  );
}
export default CkEditorTestPage;
